

import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class Currency extends EntityDto implements IEntityDto {
  Currency_Id: string;
  CurrencyCode: string;
  CurrencyName: string;
  Symbol: string;
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  TotalCount: number;
  constructor() {
    super();
    this.Currency_Id = '00000000-0000-0000-0000-000000000000';
    this.CurrencyCode = '';
    this.CurrencyName = '';
    this.Symbol = '';
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;

    this.EntityMetaData = [
      { FieldName: 'CurrencyCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
      { FieldName: 'CurrencyName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Currency Name is required' },
      { FieldName: 'Symbol', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Symbol is required' }
    ];
  }
}